<div class="modal-header">
	<h4 class="modal-title fw-bold">
		<span jhiTranslate="merge-germplasm.review.title"></span>
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
			(click)="dismiss()">
	</button>
</div>
<div class="modal-body">
	<span jhiTranslate="merge-germplasm.review.germplasm.summary" [translateValues]="{param1: germplasmMergeSummary.countGermplasmToDelete, param2: germplasmMergeSummary.countListsToUpdate}"></span>
	<br/><br/>
	<span jhiTranslate="merge-germplasm.review.studies"></span>
	<br/>
	<span jhiTranslate="merge-germplasm.review.studies.summary" [translateValues]="{param1: germplasmMergeSummary.countStudiesToUpdate, param2: germplasmMergeSummary.countPlotsToUpdate}"></span>
	<br/><br/>
	<span jhiTranslate="merge-germplasm.review.lots"></span>
	<br/>
	<span jhiTranslate="merge-germplasm.review.lots.summary" [translateValues]="{param1: germplasmMergeSummary.countLotsToMigrate, param2: germplasmMergeSummary.countLotsToClose}"></span>
	<br/><br/>
	<span jhiTranslate="merge-germplasm.review.transfer-data"></span>
	<br/>
	<div *ngIf="germplasmMergeRequest.mergeOptions.migratePassportData || germplasmMergeRequest.mergeOptions.migrateAttributesData ||
		germplasmMergeRequest.mergeOptions.migrateNameTypes || germplasmMergeRequest.mergeOptions.migrateFiles">
		<div *ngIf="germplasmMergeRequest.mergeOptions.migratePassportData" jhiTranslate="merge-germplasm.review.transfer-passport-data"></div>
		<div *ngIf="germplasmMergeRequest.mergeOptions.migrateAttributesData" jhiTranslate="merge-germplasm.review.transfer-attributes-data"></div>
		<div *ngIf="germplasmMergeRequest.mergeOptions.migrateNameTypes" jhiTranslate="merge-germplasm.review.transfer-names-types-data"></div>
		<div *ngIf="germplasmMergeRequest.mergeOptions.migratePassportData && germplasmMergeRequest.mergeOptions.migrateFiles" jhiTranslate="merge-germplasm.review.transfer-passport-files"></div>
		<div *ngIf="germplasmMergeRequest.mergeOptions.migrateAttributesData && germplasmMergeRequest.mergeOptions.migrateFiles" jhiTranslate="merge-germplasm.review.transfer-attributes-files"></div>
		<div *ngIf="germplasmMergeRequest.mergeOptions.migrateFiles" jhiTranslate="merge-germplasm.review.transfer-detached-files"></div>
	</div>
	<div *ngIf="!germplasmMergeRequest.mergeOptions.migratePassportData && !germplasmMergeRequest.mergeOptions.migrateAttributesData &&
		!germplasmMergeRequest.mergeOptions.migrateNameTypes && !germplasmMergeRequest.mergeOptions.migrateFiles">
		<span jhiTranslate="merge-germplasm.review.no-transfer-germplasm-data"></span>
		<br/>
	</div>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="dismiss()" [disabled]="isLoading">
		<span class="fa fa-ban"></span>&nbsp;
		<span jhiTranslate="cancel"></span>
	</button>
	<button (click)="confirm()" class="btn btn-primary">
		<span *ngIf="isLoading" class="throbber throbber-btn"></span>
		<span class="fa fa-save"></span>&nbsp;
		<span jhiTranslate="merge-germplasm.confirm"></span>
	</button>
</div>
